import { React, useState, useEffect } from 'react';
import GeoGebraMySol from '../components/GeoGebraMySol';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
// import '../App.css';
import ViewMyAnswerItem from '../components/ViewMyAnswerItem';

const DifficultyProblemMy = ()=> {
    const navigateto=useNavigate();
    const {dcProbIDMy}=useParams();
    const {difficultyCategoryCode, problemCode, difficultyCategoryTitle, problem, useStat, myAnswerList, isFirst, isLast, prevProblem, prevUrlAdd, nextProblem, nextUrlAdd, dcProbID, dcPhase} = useLocation().state;
    const {myConstructionStep, myAnswerRaw, myPointConstruction, errAns} = ViewMyAnswerItem({"answerMark": dcProbIDMy});
    const location = useLocation();
    const [selectedAnswer, setSelectedAnswer] = useState();
    const [randomString1, setRandomString1] = useState();
    const [myConstruct, setMyConstruct] = useState('');
    const [flag, setFlag] =useState('');

    useEffect(() => {
        setMyConstruct(myConstructionStep);
        setFlag(dcProbIDMy);
    },[myConstructionStep])

    useEffect(() => {
        const revivalData = () => {
            const letters = '1234567890';
            let randomString1l = '';
            for (let i = 0; i < 3; i++) {
                randomString1l += letters[Math.floor(Math.random() * letters.length)];
            }
            setRandomString1(randomString1l);
          };
          revivalData();
    },[dcProbIDMy])

    return(
        <div className="problem" key={myAnswerRaw.answerMark}>
            {errAns 
                ? navigateto("/login", {state:{"from": location}}, {replace: true})
                : <div className="content-fit">
                    <h4>{myAnswerRaw && `${myAnswerRaw.solvingTime.substring(6,10)}년 ${myAnswerRaw.solvingTime.substring(3,5)}월 ${myAnswerRaw.solvingTime.substring(0,2)}일 ${myAnswerRaw.solvingTime.substring(12,17)}의 풀이`}</h4>
                    <div>
                        <select value={selectedAnswer} style={{height:"36px"}} onChange={(e) => setSelectedAnswer(e.target.value)}>
                            <option value>문제를 푼 때를 선택하세요.</option>
                            {myAnswerList.map(myAns => {
                                return <option value={myAns.answerMark} key={myAns.answerMark}>
                                    {myAns.solvingTime.substring(6,10)}년 {myAns.solvingTime.substring(3,5)}월 {myAns.solvingTime.substring(0,2)}일 {myAns.solvingTime.substring(12,17)}
                                </option>
                            })}
                        </select>
                        <button 
                            className='button' 
                            style={{marginLeft:"10px"}}
                            onClick={() => navigateto(`/difficultyproblem/my/${selectedAnswer}`, {state: {
                                "difficultyCategoryCode": difficultyCategoryCode,
                                "problemCode": problemCode,
                                "difficultyCategoryTitle": difficultyCategoryTitle,
                                "problem": problem,
                                "useStat": useStat,
                                "myAnswerList": myAnswerList,
                                "isFirst": isFirst,
                                "isLast": isLast,
                                "prevProblem": prevProblem,
                                "prevUrlAdd": prevUrlAdd,
                                "nextProblem": nextProblem,
                                "nextUrlAdd": nextUrlAdd,
                                "dcProbID": dcProbID,
                                "dcPhase": dcPhase
                            }})}
                        >
                            풀이 보기
                        </button>
                    </div>
                    <div key={flag}>
                        {myConstruct.length !== 0
                            ? <GeoGebraMySol
                                    idIn={problem.problemCode}
                                    customToolBarIn={problem.customToolBar}
                                    allowStyleBarIn={problem.allowStyleBar}
                                    ggbBase64In={problem.problemContent}
                                    myPointAnswer={myPointConstruction}
                                    myAnswerStep={myConstruct}
                                    problemType={problem.problemType}
                                />
                            : "Loading"
                        }
                    </div>
                    <div className='horizontal-flex-container'>
                        {isFirst 
                            ? null 
                            : <button 
                                className='button' 
                                onClick={() => navigateto(`/difficultyproblem/${randomString1}${prevUrlAdd}`, {state:{
                                    "difficultyCategoryCode": difficultyCategoryCode,
                                    "problemCode": prevProblem,
                                    "difficultyCategoryTitle": difficultyCategoryTitle,
                                    // "improveAbilityList": improveAbilityList,
                                    "dcPhase": dcPhase
                                }})}
                            >
                                이전 문제
                            </button>
                        } 
                        {isLast 
                            ? null 
                            : <button 
                                className='button' 
                                onClick={() => navigateto(`/difficultyproblem/${randomString1}${nextUrlAdd}`, {state:{
                                    "difficultyCategoryCode": difficultyCategoryCode,
                                    "problemCode": nextProblem,
                                    "difficultyCategoryTitle": difficultyCategoryTitle,
                                    // "improveAbilityList": improveAbilityList,
                                    "dcPhase": dcPhase
                                }})}
                            >
                                다음 문제
                            </button>
                        }
                        <button 
                            className='button'
                            onClick={() => navigateto(`/difficultyproblem/${dcProbID}`, {state:{
                                "difficultyCategoryCode": difficultyCategoryCode,
                                "problemCode": problemCode,
                                "difficultyCategoryTitle": difficultyCategoryTitle,
                                // "improveAbilityList": improveAbilityList,
                                "dcPhase": dcPhase
                            }})}
                        >
                            문제로 돌아가기
                        </button>
                        {(problem.problemType === 1 || problem.problemType === 2)
                            ? <button 
                                    className='button'
                                    onClick={() => navigateto(`/difficultyproblem/my/animation/${dcProbIDMy}`, {state:{
                                        "difficultyCategoryCode": difficultyCategoryCode,
                                        "problemCode": problemCode,
                                        "difficultyCategoryTitle": difficultyCategoryTitle,
                                        "problem": problem,
                                        "useStat": useStat,
                                        "myAnswerList": myAnswerList,
                                        "isFirst": isFirst,
                                        "isLast": isLast,
                                        "prevProblem": prevProblem,
                                        // "prevProblemId": prevProblemId,
                                        "prevUrlAdd": prevUrlAdd,
                                        "nextProblem": nextProblem,
                                        // "nextProblemId": nextProblemId,
                                        "nextUrlAdd": nextUrlAdd,
                                        "dcProbID": dcProbID,
                                        "myConstructionStep": myConstructionStep,
                                        "myPointConstruction": myPointConstruction,
                                        "myAnswerRaw":myAnswerRaw,
                                        // "improveAbilityList": improveAbilityList,
                                        "dcPhase": dcPhase
                                    }})}
                                >
                                    풀이 과정 보기
                                </button>
                            : null
                        }
                    </div>
                </div>
            }
            <br/>
        </div>
    );
};

export default DifficultyProblemMy;
